angular
  .module('duplicatedCar')
  .component('duplicatedCar', {
    template: require('./duplicated-car.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function duplicatedCarViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showUserView = $rootScope.gShowUserView;
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'duplicatedCar';
        $scope.doLogout = $rootScope.gLogout;
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.total_count = 0;
        $resource(`${APIURL}/admin/duplicatedCars`).get().$promise
          .then((data) => {
            this.cars = data.duplicatedCars;
            this.total_count = data.count;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/duplicatedCars`).get({ page: page - 1 },
            (data) => {
              this.cars = data.duplicatedCars;
              this.total_count = data.count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.view = (car) => {
          this.car = car;
          $resource(`${APIURL}/admin/duplicatedCars/${car.ID}`).get().$promise
            .then((data) => {
              this.carMembers = data.members;
              jQuery('#modal-duplicated-car-members').modal('show');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/duplicated-car/duplicated-car.component.js